import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useOnSelectionChange } from '@xyflow/react'
import SydButton from '../../../commonDesign/Button'
import Icon from '../../../atoms/Icon'
import { ICON_NAMES } from '../../../../constants'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { NodeLinkSettings } from './NodeLinkSettings'

const useStyles = makeStyles({
  toggleButton: {
    position: 'absolute',
    top: 6,
    right: 6,
    zIndex: 103,
    transform: 'translate(0, 0)',
    transition: 'transform 0.3s ease-in-out'
  },
  innerContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '500px',
    background: 'color-mix(in srgb, var(--theme-color-surface-d0) 70%, transparent)',
    borderRight: 'var(--border-primary-thin)',
    padding: 'var(--padding-md)',
    boxShadow: 'var(--shadow-md)',
    backdropFilter: 'blur(10px)',
    zIndex: 101,
    transform: 'translate(-100%, 0)',
    transition: 'transform 0.3s ease-in-out',
    '&.open': {
      transform: 'translate(0, 0)'
    }
  }
})

export const LinkEditSidebar = () => {
  const classes = useStyles()
  const { state: { linkEditItem }, dispatch } = useEntityGraphContext()

  const onChange = useCallback(({ nodes, edges }) => {
    if (nodes?.length === 1 && !!linkEditItem) {
      return dispatch({
        type: 'TOGGLE_EDIT_SIDEBAR',
        payload: {
          path: 'linkEditItem',
          value: {
            id: nodes[0].id,
            type: 'node'
          }
        }
      })
    }
    dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'linkEditItem', value: null } })
  }, [dispatch, linkEditItem])

  useOnSelectionChange({
    onChange
  })

  const onClose = useCallback(() => {
    dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'linkEditItem', value: null } })
  }, [dispatch])

  return (
    <div className={classes.container}>
      <div className={clsx(classes.innerContainer, { open: !!linkEditItem })}>
        <SydButton
          className={clsx(classes.toggleButton, { open: !!linkEditItem })}
          onClick={onClose}
        >
          <Icon name={ICON_NAMES.close} size='md' />
        </SydButton>
        <h2 className='text-lg font-bold m-0'>Link Edit Item</h2>
        {linkEditItem?.type === 'node' && (
          <div key={linkEditItem?.id} className='mb-4'>
            <NodeLinkSettings nodeId={linkEditItem?.id} />
          </div>
        )}
      </div>
    </div>
  )
}
